/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Success_ToastInputs */

const en_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Successfully exported ${i?.count} images, BDN script, and FCP XML`)
};

const fr_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation reussie de ${i?.count} images, du script BDN et du XML FCP`)
};

const de_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Bilder, BDN-Skript und FCP-XML erfolgreich exportiert`)
};

const it_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Immagini ${i?.count}, script BDN e XML FCP esportati correttamente`)
};

const ru_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изображения ${i?.count}, скрипт BDN и FCP XML успешно экспортированы.`)
};

const es_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se exportaron con éxito las imágenes ${i?.count}, el script BDN y el XML FCP`)
};

const zh_cn2_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功导出 ${i?.count} 图像、BDN 脚本和 FCP XML`)
};

const ja_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 枚の画像、BDN スクリプト、FCP XML を正常にエクスポートしました`)
};

const hi_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} इमेज, बीडीएन स्क्रिप्ट और एफसीपी एक्सएमएल सफलतापूर्वक निर्यात कर दी गई हैं।`)
};

const pt_pt2_image_export_success_toast = /** @type {(inputs: Image_Export_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imagens ${i?.count}, script BDN e XML FCP exportados com sucesso.`)
};

/**
* | output |
* | --- |
* | "Successfully exported {count} images, BDN script, and FCP XML" |
*
* @param {Image_Export_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_success_toast = /** @type {((inputs: Image_Export_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_success_toast(inputs)
	if (locale === "de") return de_image_export_success_toast(inputs)
	if (locale === "it") return it_image_export_success_toast(inputs)
	if (locale === "ru") return ru_image_export_success_toast(inputs)
	if (locale === "es") return es_image_export_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_success_toast(inputs)
	if (locale === "ja") return ja_image_export_success_toast(inputs)
	if (locale === "hi") return hi_image_export_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_success_toast(inputs)
	return en_image_export_success_toast(inputs)
});